<template>
  <div id="confirm-item-modal-container" class="bg-white sm:bg-clip-padding sm:bg-black sm:backdrop-filter sm:backdrop-blur-md sm:bg-opacity-60" v-if="!hidden" :class="{opened: !hidden}">

    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
      <div>
        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100">
          <i class="fas fa-question text-gray-500 text-xl"></i>
        </div>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
            {{ title }}
          </h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500">
              {{ description }}
            </p>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button @click.prevent="confirmModal()" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-brand text-base font-medium text-white hover:bg-brand-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-light sm:col-start-2 sm:text-sm">
          {{ buttonText }}
        </button>
        <button @click.prevent="closeModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand sm:mt-0 sm:col-start-1 sm:text-sm">
          {{ cancelButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      hidden: true,
      title: 'Confirm Modal Title',
      description: 'Here is the description for a confirmation modal.',
      buttonText: 'Confirm',
      cancelButtonText: 'Cancel',
      confirmationFunction: function () {
      }
    }
  },
  computed: {},
  methods: {
    closeModal() {
      this.title = '';
      this.description = '';
      this.hidden = true;
      this.confirmationFunction = function () {
      };
    },
    confirmModal() {
      this.confirmationFunction();
      this.closeModal();
    },
    openModal() {
      this.hidden = false;
    }
  },
  mounted() {
    var that = this;

    eventBus.$on('confirm-modal-open', function (title, description, buttonText, cancelButtonText, confirmationFunction) {
      that.title = title;
      that.description = description;
      that.buttonText = buttonText;
      that.cancelButtonText = cancelButtonText;
      that.confirmationFunction = confirmationFunction;
      that.openModal();
    });

    eventBus.$on('confirm-modal-confirmed', function () {
      that.confirmationFunction();
      that.closeModal();
    });

    eventBus.$on('confirm-modal-closed', function () {
      that.closeModal();
    });

  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/setup';

#confirm-item-modal-container {
  display: none;
  &.opened {

    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 1000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

</style>
